import { type SessionOutfitSelection } from '../../services/api/sessions';

interface TimelineOutfitSelectionsProps {
  selections: SessionOutfitSelection[];
  totalPrice?: number;
  currency?: string;
}

export const TimelineOutfitSelections = ({
  selections,
  totalPrice,
  currency,
}: TimelineOutfitSelectionsProps) => {
  if (selections.length === 0) return null;

  return (
    <div className="mt-4 space-y-2 rounded-xl border border-slate-200 bg-slate-50 p-2.5">
      <div className="flex items-center justify-between gap-2">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Valda produkter
          </div>
          <div className="text-xs text-slate-500">
            {selections.length} produkter
            {totalPrice ? ` • Ca ${totalPrice} ${currency || 'SEK'}` : ''}
          </div>
        </div>
      </div>
      <div className="space-y-2">
        {selections.map((product) => (
          <a
            key={`${product.categoryKey || 'product'}-${product.productId}`}
            href={product.url || '#'}
            target={product.url ? '_blank' : undefined}
            rel={product.url ? 'noreferrer' : undefined}
            className="group flex items-stretch gap-3 overflow-hidden rounded-lg border border-slate-200 bg-white p-2 transition hover:border-slate-300 hover:shadow-sm"
          >
            <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md bg-slate-100">
              {product.imageUrl ? (
                <img
                  src={product.imageUrl}
                  alt={product.productName}
                  className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
                />
              ) : (
                <div className="flex h-full items-center justify-center text-xs text-slate-400">
                  Ingen bild
                </div>
              )}
            </div>
            <div className="min-w-0 flex-1 space-y-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-[10px] uppercase tracking-wide text-slate-500">
                  {product.categoryKey || 'produkt'}
                </span>
                {product.brand && (
                  <span className="truncate text-[10px] text-slate-500">{product.brand}</span>
                )}
              </div>
              <div className="line-clamp-2 text-xs font-semibold leading-4 text-slate-900">
                {product.productName}
              </div>
              <div className="flex items-center justify-between gap-2 text-[11px] text-slate-600">
                <span className="font-medium text-slate-900">
                  {typeof product.price === 'number'
                    ? `${product.price} ${product.currency || 'SEK'}`
                    : 'Pris saknas'}
                </span>
                <span className="truncate text-[10px] text-slate-400">{product.productId}</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
